<template>
    <div>
        <div class="btn-group btn-group mb-2" role="group" aria-label="Manage rewards">
            <button class="btn btn-sm btn-primary" type="button" @click="addReward">+</button>
            <button class="btn btn-sm btn-secondary" type="button" @click="removeReward">-</button>
        </div>
        <div class="d-flex rewards-container" v-for="(reward, index) in rewards" :key="index">
            <div class="reward-field">
                <label class="control-label reward-label">Place
                    <input class="form-control" type="number" min="1" v-model.number="reward.place">
                </label>
            </div>
            <div class="reward-field-lg">
                <label class="control-label reward-label">Item
                    <v-select v-model="reward.protoAlias"
                        @search="searchItem"
                        :options="options"
                        :filterable="false"></v-select>
                </label>
            </div>
            <div class="reward-field">
                <label class="control-label reward-label">Amount
                    <input class="form-control" type="number" min="1" v-model.number="reward.amount">
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';

import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

export default {
    name: 'RewardsInput',
    components: {
        vSelect,
    },

    data() {
        return {
            rewards: [],
            options: [],
        };
    },

    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    watch: {
        rewards: {
            handler(newValue) {
                this.$emit('input', newValue);
            },
            deep: true,
        },
        value(newValue) {
            this.rewards = newValue;
        },
    },

    methods: {
        addReward() {
            this.rewards.push({});
        },

        removeReward() {
            this.rewards.pop();
        },
        
        searchItem(itemAlias, loading) {
            if (!itemAlias) {
                return;
            }

            loading(true);

            HTTP.get('/configs/search', {
                params: {q: itemAlias}
            })
            .then(response => {
                const result = response.data.data || [];
                this.options = result.map(cfg => cfg.alias);
                loading(false);
            })
            .catch(e => {
                notifier.showError(e, {sender: this});
                loading(false);
            })
        },
    },
}
</script>

<style scoped>
.rewards-container {
  gap: 1em;
}
.reward-field {
  flex: 2 0 0;
}
.reward-field-lg {
  flex: 10 0 0;
}
.reward-label {
  width: 100%;
}
</style>